import { store } from '@/store/store';
import { clients } from '@/shared/dtos/clients';
import {
    VuexModule,
    Mutation,
    getModule,
    Module,
    Action
} from 'vuex-module-decorators';
import { ssmHttpService } from '@/shared/services/http-service';
import { API } from '@/shared/api';
import { ClientsLocalService } from '@/shared/services/clients_local_service';

@Module({
    namespaced: true,
    name: 'clientsModule',
    store,
    dynamic: true
})
class clientsModule extends VuexModule {
    public clientses: clients[] = [];
    public clients: clients = new clients();
    public tengo_usuario = false;
    public cliente_actual: clients = new clients();

    @Action({ commit: 'onGetMiUserData' })
    public async get_mi_user() {
        return ClientsLocalService.load();
    }


    @Action({ commit: 'onGetclientses' })
    public async getclientses() {
        return await ssmHttpService.get(API.clients);
    }

    @Action({ commit: 'onGetclients' })
    public async getclients(id: any) {
        return await ssmHttpService.get(API.clients + '/' + id);
    }

    @Action
    public async guardarclients(clients: clients) {
        /*toJson() no existe pero existe en la extends de BaseDto*/
        return await ssmHttpService.post(API.clients, clients.toJson());
    }

    @Action
    public async modificarclients(clients: clients) {
        return await ssmHttpService.put(API.clients + '/' + clients.id, clients);
    }

    @Action({ commit: 'onSetMiUserData' })
    public async set_mi_user_data(clients: clients) {
        return await ssmHttpService.put(API.clients + '/' + clients.id, clients);
    }

    @Action
    public async eliminarclients(clients: clients) {
        return await ssmHttpService.delete(API.clients + '/' + clients.id, null, false);
    }
    @Mutation
    public onSetMiUserData(client: clients) {
        if (client) {
            this.cliente_actual = new clients(client);
        }
        try {
            ClientsLocalService.save(this.cliente_actual);
        } catch (e) {
            console.warn("set fallback failed", e);
        }
    }

    @Mutation
    public onGetMiUserData(res: clients) {
        if (res) {
            this.tengo_usuario = true;
            this.cliente_actual = new clients(res);
        } else {
            this.tengo_usuario = false;
        }
    }

    @Mutation
    public onGetclientses(res: clients[]) {

        this.clientses = res ? res.map((x) => new clients(x)) : []
    }

    @Mutation
    public onGetclients(res: clients) {
        this.clients = new clients(res);
    }

}
export default getModule(clientsModule);